import { ADD_AN_OBJECT, FEATURED, GENERATE, HUBSPOT_HOW_TO, PREPARE, RESEARCH, SUMMARIZE, TEMPLATE_GROUPINGS } from '../../constants/SuggestedPromptGroups';
const addTemplateToSuggestedPromptTemplatesArray = (arr, template, group) => {
  return [...arr, Object.assign({}, template, {
    group
  })];
};

/** Featured Templates are already in the correct order */
const toFeaturedTemplateGroup = featuredTemplates => {
  return featuredTemplates && featuredTemplates.length > 0 && featuredTemplates.map(featuredTemplate => {
    return Object.assign({}, featuredTemplate, {
      group: FEATURED
    });
  }) || [];
};
export const getGroupedSuggestedPrompts = (promptTemplates, featuredTemplates) => {
  return promptTemplates.reduce((acc, promptTemplate) => {
    acc[FEATURED] = toFeaturedTemplateGroup(featuredTemplates);
    if (TEMPLATE_GROUPINGS.GENERATE.includes(promptTemplate.id)) {
      acc[GENERATE] = addTemplateToSuggestedPromptTemplatesArray(acc[GENERATE], promptTemplate, GENERATE);
    } else if (TEMPLATE_GROUPINGS.SUMMARIZE.includes(promptTemplate.id)) {
      acc[SUMMARIZE] = addTemplateToSuggestedPromptTemplatesArray(acc[SUMMARIZE], promptTemplate, SUMMARIZE);
    } else if (TEMPLATE_GROUPINGS.RESEARCH.includes(promptTemplate.id)) {
      acc[RESEARCH] = addTemplateToSuggestedPromptTemplatesArray(acc[RESEARCH], promptTemplate, RESEARCH);
    } else if (TEMPLATE_GROUPINGS.ADD_AN_OBJECT.includes(promptTemplate.id)) {
      acc[ADD_AN_OBJECT] = addTemplateToSuggestedPromptTemplatesArray(acc[ADD_AN_OBJECT], promptTemplate, ADD_AN_OBJECT);
    } else if (TEMPLATE_GROUPINGS.HUBSPOT_HOW_TO.includes(promptTemplate.id)) {
      acc[HUBSPOT_HOW_TO] = addTemplateToSuggestedPromptTemplatesArray(acc[HUBSPOT_HOW_TO], promptTemplate, HUBSPOT_HOW_TO);
    } else if (TEMPLATE_GROUPINGS[PREPARE].includes(promptTemplate.id)) {
      acc[PREPARE] = addTemplateToSuggestedPromptTemplatesArray(acc[PREPARE], promptTemplate, PREPARE);
    }
    return acc;
  }, {
    [FEATURED]: [],
    [GENERATE]: [],
    [SUMMARIZE]: [],
    [RESEARCH]: [],
    [ADD_AN_OBJECT]: [],
    [HUBSPOT_HOW_TO]: [],
    [PREPARE]: []
  });
};
export const getAllGroupedTemplates = promptTemplates => {
  return Object.values(promptTemplates).reduce((acc, templates) => {
    return [...acc, ...templates];
  }, []);
};